module.exports = __webpack_public_path__ + "static/media/scan_joke.41a503ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/scan_joke.png
// module id = 563
// module chunks = 0